import React from "react";
import {Nav, Navbar as NavB, NavItem} from "reactstrap";

const NavBar = () => {
    return <NavB color="white" style={{padding: "10px"}} light>
        <Nav style={{justifyContent: "space-between", width: "100%"}}>
            <NavItem style={{width: "fit-content", maxWidth: "175px", minWidth: "140px", margin: "3px"}}>
                <a href="https://www.korem.com" rel="noopener noreferrer" target="_blank">
                    <img
                        src="https://www.korem.com/wp-content/themes/theme_korem/images/svg/korem.svg"
                        alt="KoremLogo"
                        width="100%"
                        height="36"/>
                </a>
            </NavItem>

            <NavItem className="rectangular-button" style={{width: "fit-content", margin: "3px"}}>
            <a href="https://www.korem.com/contact/form/" rel="noopener noreferrer" target="_blank">Contact us</a>
        </NavItem>
        </Nav>
    </NavB>
};

export default NavBar;
